
.af,
.af *,
.af *::before,
.af *::after {
  box-sizing: border-box;
}

.af {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: visible;
}

.af-inner {
  max-width: 1200px;
  margin: 0 auto;
  overflow: visible;
}

.af-header {
  max-width: 760px;
  margin-bottom: 1.75rem;
}

.af-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.5rem;
}

.af-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.af-title {
  margin: 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.af-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.af-stage {
  position: relative;
  margin-top: 1rem;
  padding-bottom: 2rem;
}

.af-video-frame {
  position: relative;
  width: min(100%, 1080px);
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #090909;
  box-shadow:
    0 2px 6px rgba(10, 10, 10, 0.08),
    0 20px 50px rgba(10, 10, 10, 0.18);
}

.af-video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: cover !important;
  pointer-events: none;
  display: block;
}

.af-video::-webkit-media-controls,
.af-video::-webkit-media-controls-enclosure,
.af-video::-webkit-media-controls-panel,
.af-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none !important;
}

.af-body-wrap {
  position: absolute;
  right: 1.25rem;
  bottom: 0;
  width: min(460px, calc(100% - 2.5rem));
  padding: 1.05rem 1.15rem;
  border-radius: 10px;
  border: 1px solid rgba(10, 10, 10, 0.1);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-shadow: 0 16px 36px rgba(10, 10, 10, 0.12);
}

.af-body {
  margin: 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.58;
  color: #2f2f37;
  font-weight: 500;
}

.af-body-lead {
  font-size: clamp(1.02rem, 1.2vw, 1.18rem);
  color: #222228;
}

@media (max-width: 960px) {
  .af-header {
    max-width: none;
    margin-bottom: 1.25rem;
  }

  .af-stage {
    padding-bottom: 0;
  }

  .af-video-frame {
    width: 100%;
    border-radius: 6px;
  }

  .af-body-wrap {
    position: static;
    margin-top: 1rem;
    width: 100%;
    padding: 1rem;
    box-shadow: none;
  }
}

@media (max-width: 540px) {
  .af-title {
    font-size: clamp(1.9rem, 7vw, 2.5rem);
  }

  .af-eyebrow {
    margin-bottom: 1.25rem;
  }

  .af-body,
  .af-body-lead {
    font-size: 1rem;
    line-height: 1.55;
  }
}
